const videoIframeCheck = () => {
  const iframe = document.querySelector(".hero iframe");

  if (!iframe) return;

  iframe.addEventListener("load", () => {
    iframe.classList.add("is-loaded");
  });
};

const eventsFilter = () => {
  const filters = document.querySelectorAll(".events-filter .tag");
  const activeCategory = document.querySelector(".events-filter .tag.is-active")?.getAttribute("data-filter");

  filters.forEach((filter) => {
    filter.addEventListener("click", (e) => {
      const category = e.target.getAttribute("data-filter");
      const events = document.querySelectorAll("article.event");

      filters.forEach((f) => f.classList.remove("is-active"));
      const activeButtonSelector = e.target.getAttribute("data-filter");

      document.querySelectorAll(`[data-filter=${activeButtonSelector}]`).forEach((el) => {
        el.classList.add("is-active");
      });

      events.forEach((event) => {
        if (category === "all") {
          event.classList.remove("is-hidden");
          return;
        }

        if (event.getAttribute("data-category") === category) {
          event.classList.remove("is-hidden");
        } else {
          event.classList.add("is-hidden");
        }
      });
    });
  });
};
const mobileSubMenu = () => {
  const toggle = document.querySelector(".menu-item-has-children");
  const subMenu = toggle.querySelector(".sub-menu");

  toggle.addEventListener("click", (e) => {
    if (e.target.getAttribute("href") === '#') {
      e.preventDefault();
    }
    subMenu.classList.toggle("is-active");
  });
};

const spotlightSlider = () => {
  const swiper = new Swiper(".spotlight-slider", {
    loop: true,
    infinite: true,
    slidesPerView: 1.3,
    spaceBetween: 16,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: ".spotlight-swiper-button-next",
      prevEl: ".spotlight-swiper-button-prev",
    },
    breakpoints: {
      600: {
        slidesPerView: 2.3,
        spaceBetween: 16,
      },
      992: {
        slidesPerView: 3.3,
        spaceBetween: 24,
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 24,
      },
    },
  });
};

const flexibleMembership = () => {
  const swiper = new Swiper(".flexible-membership-slider", {
    loop: true,
    infinite: true,
    slidesPerView: 1,
    spaceBetween: 0,
    navigation: {
      nextEl: ".location-swiper-button-next",
      prevEl: ".location-swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
    },
  });
};

const locationSlider = () => {
  const swiper = new Swiper(".location-slider", {
    loop: true,
    infinite: true,
    slidesPerView: 1,
    spaceBetween: 16,
    navigation: {
      nextEl: ".location-swiper-button-next",
      prevEl: ".location-swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
    },
  });
};
const aboutTeamSwiper = () => {
  const swiper = new Swiper(".about-team__members-slider", {
    loop: true,
    infinite: true,
    slidesPerView: 1.8,
    spaceBetween: 16,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: ".members-swiper-button-next",
      prevEl: ".members-swiper-button-prev",
    },
    breakpoints: {
      600: {
        slidesPerView: 2.8,
        spaceBetween: 16,
      },
      992: {
        slidesPerView: 3.8,
        spaceBetween: 24,
      },
      1200: {
        slidesPerView: 5,
        spaceBetween: 48,
      },
    },
  });
};
const globalSwiper = () => {
  const swiper = new Swiper(".block-slider.swiper", {
    loop: true,
    infinite: true,
    slidesPerView: 1,
    spaceBetween: 24,
  });
};
const videoPlayer = () => {
  const container = document.querySelector(".flexible-background-video");
  if (!container) return;

  const video = container.querySelector("video");
  const muteButton = container.querySelector("button");

  if (!video) return;
  if (!muteButton) return;

  muteButton.addEventListener("click", () => {
    if (video.muted) {
      video.muted = false;
      container.classList.remove("muted");
    } else {
      video.muted = true;
      container.classList.add("muted");
    }
  });
};
const partnersSlider = () => {
  const swiper = new Swiper(".partners__slider", {
    loop: true,
    infinite: true,
    slidesPerView: 1,
    spaceBetween: 0,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    breakpoints: {
      450: {
        slidesPerView: "auto",
      },
    },
  });
};
const faqAccordion = () => {
  const faqs = document.querySelectorAll(".faq");
  faqs?.[0]?.classList.add("is-active");

  faqs.forEach((faq) => {
    const header = faq.querySelector("header");
    const body = faq.querySelector(".faq-body");
    header.addEventListener("click", (e) => {
      faq.classList.toggle("is-active");
    });
  });
};

const pricingTablesAccordion = () => {
  const containers = document.querySelectorAll(".pricing-table-container");

  containers.forEach((container) => {
    const header = container.querySelector("header");
    header.addEventListener("click", (e) => {
      container.classList.toggle("active");
    });
  });
};

const updateHeaderOpacity = () => {
  const header = document.querySelector(".site-header");
  const scrollY = window.scrollY;

  const opacity = Math.min(1, 0.5 + (scrollY / 100) * 0.5);
  const stickyOpacity = Math.min(1, 0 + (scrollY / 100) * 1);

  document.body.style.setProperty("--sticky-opacity", stickyOpacity);
  header.style.setProperty("--header-opacity", opacity);
};

const eventReadMore = () => {
  const buttons = document.querySelectorAll(".event-read-more");
  buttons.forEach((button) => {
    button.addEventListener("click", (e) => {
      e.preventDefault();
      e.target.classList.toggle("is-active");
      e.target.parentNode.querySelector(".event__content__copy .the_content").classList.toggle("open");
    });
  });
};

const updateActiveTabs = (active) => {
  const tabs = document.querySelectorAll(".events__location-tabs nav ul li a");
  const tabBody = document.querySelectorAll(".events__location-tabs__body");

  if (active === undefined) {
    active = window.location.hash;
  }

  tabs.forEach((tab, i) => {
    if (tab.getAttribute("href") === active) {
      tab.classList.add("is-active");
    } else {
      tab.classList.remove("is-active");
    }

    if (i === 0 && !active) {
      tab.classList.add("is-active");
    }
  });
  tabBody.forEach((body, j) => {
    if (body.getAttribute("data-location") === active) {
      body.classList.add("is-active");
    } else {
      body.classList.remove("is-active");
    }

    if (j === 0 && !active) {
      body.classList.add("is-active");
    }
  });
};

const eventTabs = () => {
  updateActiveTabs();
  const tabs = document.querySelectorAll(".events__location-tabs nav ul li a");
  tabs.forEach((tab) => {
    tab.addEventListener("click", (e) => {
      updateActiveTabs(tab.getAttribute("href"));
    });
  });
};

const calculateMargin = () => {
  const container = document.querySelector(".container");
  if (!container) return;
  const computedMargin = window.getComputedStyle(container).marginLeft;
  if (!computedMargin) return;
  return parseFloat(computedMargin);
};

const calculatePadding = () => {
  const container = document.querySelector(".container");
  if (!container) return;
  const computedMargin = window.getComputedStyle(container).paddingLeft;
  if (!computedMargin) return;
  return parseFloat(computedMargin);
};

const mobileMenuToggle = () => {
  const navigation = document.getElementById("site-navigation");
  const header = document.querySelector(".site-header");

  const button = navigation.querySelector(".menu-toggle");

  button.addEventListener("click", (e) => {
    e.preventDefault();

    header.classList.toggle("is-active");
    document.body.classList.toggle("overflow-mobile-hidden");
  });
};

const locationsSlider = () => {
  const links = document.querySelectorAll("section.locations .locations__layout a");
  const images1 = document.querySelectorAll("section.locations .locations__layout .location__preview .location__preview__first img");
  const images2 = document.querySelectorAll("section.locations .locations__layout .location__preview .location__preview__second img");
  const images3 = document.querySelectorAll("section.locations .locations__layout .location__preview .location__preview__third img");
  const figure1 = document.querySelector("section.locations .locations__layout .location__preview .location__preview__first");
  const figure2 = document.querySelector("section.locations .locations__layout .location__preview .location__preview__second");
  const figure3 = document.querySelector("section.locations .locations__layout .location__preview .location__preview__third");
  const AMOUNT = 20;

  links[0]?.classList.add("is-active");
  images1[0]?.classList.add("is-active");
  images2[0]?.classList.add("is-active");
  images3[0]?.classList.add("is-active");

  links.forEach((link, i) => {
    link.addEventListener("mouseenter", (e) => {
      const id = e.target.getAttribute("data-id");
      links.forEach((el) => el.classList.remove("is-active"));
      e.target.classList.add("is-active");
      figure1.style.setProperty("--x", Math.floor(Math.random() * (AMOUNT - AMOUNT * -1 + 1) + AMOUNT * -1) + "px");
      figure1.style.setProperty("--y", Math.floor(Math.random() * (AMOUNT - AMOUNT * -1 + 1) + AMOUNT * -1) + "px");

      figure1.style.setProperty("--w", Math.floor(Math.random() * (74 - 70 + 1) + 74) + "%");

      figure2.style.setProperty("--x", Math.floor(Math.random() * (AMOUNT - AMOUNT * -1 + 1) + AMOUNT * -1) + "px");
      figure2.style.setProperty("--y", Math.floor(Math.random() * (AMOUNT - AMOUNT * -1 + 1) + AMOUNT * -1) + "px");

      figure2.style.setProperty("--w", Math.floor(Math.random() * (40 - 36 + 1) + 40) + "%");

      figure3.style.setProperty("--x", Math.floor(Math.random() * (AMOUNT - AMOUNT * -1 + 1) + AMOUNT * -1) + "px");
      figure3.style.setProperty("--y", Math.floor(Math.random() * (AMOUNT - AMOUNT * -1 + 1) + AMOUNT * -1) + "px");

      figure3.style.setProperty("--w", Math.floor(Math.random() * (45 - 40 + 1) + 45) + "%");

      images1.forEach((img) => {
        if (img.getAttribute("data-id") == id) {
          images1.forEach((i) => i.classList.remove("is-active"));
          img.classList.add("is-active");
        }
      });

      images2.forEach((img) => {
        if (img.getAttribute("data-id") == id) {
          images2.forEach((i) => i.classList.remove("is-active"));
          img.classList.add("is-active");
        }
      });

      images3.forEach((img) => {
        if (img.getAttribute("data-id") == id) {
          images3.forEach((i) => i.classList.remove("is-active"));
          img.classList.add("is-active");
        }
      });
    });
  });
};

const updateTestimonialsPosition = () => {
  const sliderElement = document.querySelector(".testimonials__slider");
  if (!sliderElement) return;
  sliderElement.style.paddingLeft = calculateMargin() + calculatePadding() + "px";
};

const updateCTAPosition = () => {
  const left = document.getElementById("card-content-left");
  const right = document.getElementById("card-content-right");
  if (left && right) {
    left.style.paddingLeft = calculateMargin() + calculatePadding() + "px";
    right.style.paddingRight = calculateMargin() + calculatePadding() + "px";
  }
};

const testimonialsSlider = () => {
  updateTestimonialsPosition();
  const swiper = new Swiper(".testimonials__slider", {
    loop: true,
    infinite: true,
    slidesPerView: 1.19,
    spaceBetween: 36,
    autoplay: {
      delay: 3500,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: ".custom-swiper-button-next",
      prevEl: ".custom-swiper-button-prev",
    },
    breakpoints: {
      768: {
        slidesPerView: "auto",
      },
    },
  });
};

const initStickyButton = (delay = 900) => {
  let lastScroll = window.pageYOffset || document.documentElement.scrollTop;
  const btn = document.getElementById('sticky-btn');
  if (!btn) return;

  let showTimeout = null;
  let hasShownOnce = false;

  window.addEventListener('scroll', () => {
    const current = window.pageYOffset || document.documentElement.scrollTop;

    // Scrolling down
    if (current > lastScroll) {
      // if we haven't shown it yet, schedule the delayed show
      if (!hasShownOnce && !showTimeout) {
        showTimeout = setTimeout(() => {
          btn.classList.add('show');
          btn.classList.remove('hide');
          hasShownOnce = true;      // ensure this only runs once
          showTimeout = null;
        }, delay);
      }
      // if it's already been shown once, show immediately on further scroll-downs
      if (hasShownOnce) {
        btn.classList.add('show');
        btn.classList.remove('hide');
      }
    }
    // Scrolling up
    else if (current < lastScroll) {
      // cancel pending initial show if scrolling back up before delay elapses
      if (showTimeout) {
        clearTimeout(showTimeout);
        showTimeout = null;
      }
      btn.classList.add('hide');
      btn.classList.remove('show');
    }

    lastScroll = current <= 0 ? 0 : current;
  });
};



window.addEventListener("resize", updateTestimonialsPosition);
window.addEventListener("scroll", updateHeaderOpacity);
window.addEventListener("resize", updateCTAPosition);

document.addEventListener("DOMContentLoaded", function () {
  videoIframeCheck();
  eventsFilter();
  mobileSubMenu();
  spotlightSlider();
  flexibleMembership();
  locationSlider();
  aboutTeamSwiper();
  globalSwiper();
  videoPlayer();
  partnersSlider();
  faqAccordion();
  pricingTablesAccordion();
  updateCTAPosition();
  updateHeaderOpacity();
  eventReadMore();
  eventTabs();
  testimonialsSlider();
  mobileMenuToggle();
  locationsSlider();
  initStickyButton();
});
